import Collapse from 'bootstrap/js/dist/collapse'

export default class MobileMainMenu {
  constructor(element) {

		const mainMenuBar = document.getElementById('burguer-mobile-menu-bar')
		const collapse = new Collapse(element, {
			toggle: false
		})

		if (mainMenuBar) {
			mainMenuBar.addEventListener('click', () => {
				collapse.toggle()
			});
		}
  }
}